import extranetClient from "../client";
import keycloakClient from "../keycloakClient";



const getUser = async (token) => {
    try {
        const headers = {
            'content-type': 'application/json',
            'authorization': `Bearer ${token}`
        };
        return await extranetClient.get("user", {headers: headers}).json();
    } catch (error) {
        if (error.name === 'HTTPError') {
            return await error.response.json();
        }
    }
}

const getProfilsSuggestions = async (token, data) => {
    try {
        const headers = {
            'content-type': 'application/json',
            'authorization': `Bearer ${token}`
        };

        const options = {
            headers: headers,
            json: data
        }


        return await extranetClient.post("get-profils-suggestions", options).json();
    } catch (error) {
        if (error.name === 'HTTPError') {
            return await error.response.json();
        }
    }
}

const updateUserInformations = async (token, extranetUuid, data) => {

    try {
        const headers =  {
            'content-type': 'application/json',
            'authorization': `Bearer ${token}`
        };

        const options = {
            headers: headers,
            json: data
        }

        return await extranetClient.put(`user/${extranetUuid}/profil`, options).json();


    } catch (error) {
        if (error.name === 'HTTPError') {
            return await error.response.json();
        }
    }

}

const updateUserEmail = async (token, extranetUuid, data) => {
    try {
        const headers =  {
            'content-type': 'application/json',
            'authorization': `Bearer ${token}`
        };

        const options = {
            headers: headers,
            json: data
        }

        return await extranetClient.put(`user/${extranetUuid}/email`, options).json();

    } catch (error) {
        if (error.name === 'HTTPError') {
            return await error.response.json();
        }
    }
}

const updateUserPassword = async (token, extranetUuid, data) => {
    try {
        const headers =  {
            'content-type': 'application/json',
            'authorization': `Bearer ${token}`
        };

        const options = {
            headers: headers,
            json: data
        }

        return await extranetClient.put(`user/${extranetUuid}/password`, options).json();

    } catch (error) {
        if (error.name === 'HTTPError') {
            return await error.response.json();
        }
    }
}


const getTokenByPasswordGrantAccess = async (realm, grantType, clientId, username, password) => {
    try {
        const headers =  {
            'content-type': 'application/x-www-form-urlencoded',
        };

        const urlencoded = new URLSearchParams();
        urlencoded.append("client_id", clientId);
        urlencoded.append("grant_type", grantType);
        urlencoded.append("username", username);
        urlencoded.append("password", password);
        urlencoded.append("scope", "openid");


        const options = {
            headers: headers,
            body: urlencoded,
        }
        return await keycloakClient.post(`realms/${realm}/protocol/openid-connect/token`, options).json();
        //session_code=YGQjKGWFjESdbCXtyQcONa3nejQAOyRl-imIcK1DYW8&
        //execution=eb297409-000b-44dd-99eb-24c6ffbc7e49&
        //&tab_id=lxotYY3Y8QU
        // return await keycloakClient.post(`realms/${realm}/login-actions/authenticate?client_id=extranet-react-auth-client`, options).json();

    } catch (error) {
        if (error.name === 'HTTPError') {
            return await error.response.json();
        }
    }
}

export default {
    getUser,
    updateUserEmail,
    updateUserPassword,
    getProfilsSuggestions,
    updateUserInformations,
    getTokenByPasswordGrantAccess
}
